/** @jsx jsx */
import { Header as ThemeHeader, jsx } from "theme-ui"
import PropTypes from "prop-types"
import { useState, useEffect } from "react"
import Img from "gatsby-image/withIEPolyfill"

import LanguageSwitcher from "./language-switcher"
import SearchTriggerConsumer from "./search-trigger-consumer"
import Link from "./link"
import { ab } from "../theme"

const Header = ({
  logos,
  currentMode,
  currentLanguage,
  currentURL,
  seoLinks,
}) => {
  const logo = logos[currentMode] ? logos[currentMode] : logos["default"]

  const [mobileVisible, setMobileVisible] = useState(true)
  const [prev, setPrev] = useState(0)
  const [current, setCurrent] = useState(0)

  useEffect(() => {
    const handleNavigation = e => {
      const window = e.currentTarget
      if (window.scrollY > 0) {
        setCurrent(window.scrollY)
      }
    }
    window.addEventListener("scroll", e => handleNavigation(e), false)
  }, [])

  useEffect(() => {
    if (prev > current) {
      setMobileVisible(true)
      setPrev(current)
    } else if (prev < current) {
      setMobileVisible(false)
      setPrev(current)
    }
  }, [prev, current])

  return (
    <ThemeHeader
      sx={{
        transition: "all 300ms",
        transform: ab({
          _: mobileVisible ? "translateY(0%)" : "translateY(-100%)",
          md: "none",
        }),
      }}
      className="page-header"
    >
      <div
        sx={{
          variant: "logo.container",
        }}
        className="page-logo-container"
      >
        <Link to={logo.home} language={currentLanguage} seoLinks={seoLinks}>
          <span sx={{ variant: "logo.img" }}>
            <Img fixed={logo.fixed} alt="Logo" />
          </span>
        </Link>
        <div sx={{ variant: "header.navigation" }}>
          <div sx={{ variant: "header.languageSwitcher" }}>
            <LanguageSwitcher
              currentLanguage={currentLanguage}
              currentURL={currentURL}
              seoLinks={seoLinks}
            />
          </div>
          <div
            sx={{ variant: "header.searchTrigger" }}
            className="search-trigger-container"
          >
            <SearchTriggerConsumer />
          </div>
        </div>
      </div>
    </ThemeHeader>
  )
}

Header.propTypes = {
  logos: PropTypes.object.isRequired,
  currentMode: PropTypes.oneOf([
    "default",
    "group",
    "pharma",
    "food",
    "environment",
    "contact",
  ]).isRequired,
  currentURL: PropTypes.string.isRequired,
  seoLinks: PropTypes.object.isRequired,
}

Header.defaultProps = {
  currentMode: "default",
}

export default Header
